import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import type { CupetFuelType, CupetServicenter, CupetStockEntry } from '@tucupet/shared';
import { PageHeader, Table, Card } from '../components/ui';
import { api } from '../lib/api';

interface StockResp {
  distributorName: string;
  entries: CupetStockEntry[];
}

export default function CupetStockPage() {
  const stock = useQuery<StockResp>({ queryKey: ['admin', 'cupet', 'stock'], queryFn: () => api('/api/admin/cupet/stock') });
  const fuels = useQuery<{ items: CupetFuelType[] }>({ queryKey: ['admin', 'cupet', 'fuel-types'], queryFn: () => api('/api/admin/cupet/fuel-types'), staleTime: 5 * 60_000 });
  const centers = useQuery<{ items: CupetServicenter[] }>({ queryKey: ['admin', 'cupet', 'servicenters'], queryFn: () => api('/api/admin/cupet/servicenters'), staleTime: 5 * 60_000 });

  const fuelName = (id: number) => fuels.data?.items.find((f) => f.typeFuelId === id)?.typeFuelName;
  const centerName = (id: number) => centers.data?.items.find((s) => s.servicenterId === id)?.servicenterName;

  return (
    <div>
      <Link to="/cupet" className="mono" style={{ color: 'var(--text-3)', fontSize: 12, textDecoration: 'none' }}>← Asignaciones</Link>
      <div style={{ height: 12 }} />
      <PageHeader kicker="COMBUSTIBLE CUPET" title="Stock del distribuidor" sub={stock.data?.distributorName ? `Distribuidor: ${stock.data.distributorName}` : 'Existencias asignadas por servicentro.'} />

      {stock.isError ? (
        <Card><div style={{ color: 'var(--danger)', fontSize: 13 }}>No se pudo obtener el stock desde CUPET.</div></Card>
      ) : (
        <Table<CupetStockEntry>
          rows={stock.data?.entries ?? []}
          empty={stock.isLoading ? 'Cargando…' : 'Sin existencias reportadas para este distribuidor.'}
          columns={[
            { key: 'sc', label: 'Servicentro', render: (r) => <span>{centerName(r.servicenterId) ?? <span className="mono">#{r.servicenterId}</span>}</span> },
            { key: 'fuel', label: 'Combustible', render: (r) => <span>{fuelName(r.codFuelOil) ?? <span className="mono">#{r.codFuelOil}</span>}</span> },
            { key: 'amount', label: 'Cantidad', render: (r) => <span className="mono" style={{ fontWeight: 600 }}>{r.amount.toLocaleString('es-MX')} L</span> },
          ]}
        />
      )}
    </div>
  );
}
